module.exports = __webpack_public_path__ + "img/article-image-1.04f2d7e7.webp";